import * as d3 from 'd3'
export default {
  methods: {

    verify_Diagram(selection) {

      this.diaFields = []
      let keys = Object.keys(this.db_Diagram[0])
      keys.forEach((key, i) => {
        this.diaFields.push({code: key})
      })

      let newData = {}
      this.diaFields.forEach(d=> {
        if(d3.select(`#FORM_${d.code}`).empty()) {
          newData[d.code] = ''
        } else {
          newData[d.code] = d3.select(`#FORM_${d.code}`).text()
        }
      })

      let message = []
      if(newData.SN == '' || newData.DIAGRAM == '' || newData.MANAGER == '') {
        // Required fields
        message[0] = {text: `Please fill in all required fields.`}
        this.gmx_openPopup(selection, {type: 'Alert', msg: message})
      } else if(this.db_Diagram.find(f=> f.DIAGRAM == newData.DIAGRAM) && this.winProps.mode == 'new') {
        // Already exists
        message[0] = {text: `This diagram name already exists.`}
        message[1] = {text: `Please choose another.`}
        this.gmx_openPopup(selection, {type: 'Alert', msg: message})
      } else {
        if(this.winProps.mode == 'new') this.insert_Diagram(newData)
        if(this.winProps.mode == 'update') this.update_Diagram(newData)
        if(this.winProps.mode == 'edit') this.update_Diagram(newData)
        // console.log('newData ->', newData) //
      }

    },


    insert_Diagram(newData) {
      // INSERT
      this.dia_Insert(newData).then(() => {
        this.db_Diagram = this.cbData.data
        this.close_Window()

        d3.select(`#PHASE_${newData.PHASE}`).remove()
        this.draw_DiagramList(this.phase.list.find(f=> f.code == newData.PHASE)) // -----> draw_Database.js
      })
    },


    update_Diagram(newData) {
      // UPDATE
      this.dia_Update(newData, `IDX = ${newData.IDX}`).then(() => {
        this.db_Diagram = this.cbData.data
        this.close_Window()

        d3.select(`#PHASE_${newData.PHASE}`).remove()
        this.draw_DiagramList(this.phase.list.find(f=> f.code == newData.PHASE)) // -----> draw_Database.js

        if(this.winProps.mode == 'edit') {
          let updated = newData.CTO_DATE ? new Date(newData.CTO_DATE) : null
          d3.select(`#CUTOFF_MONTH`).text(updated ? updated.toLocaleString('en-US', { month: 'short' }) : '')
          d3.select(`#CUTOFF_DAY`).text(updated ? updated.getDate() : '')
          this.winProps.data = newData
        }
      })
    },


    async del_Diagram(props) {
      let dia = this.db_Diagram.find(f=> f.IDX == props.idx)
      // DELETE
      await this.stg_Delete(`IDX = ${dia.IDX}`)
        this.db_Stage = this.cbData.data

      await this.tbl_Delete(`IDX = ${dia.IDX}`)
        this.db_Talbe = this.cbData.data

      await this.dia_Delete(`IDX = ${dia.IDX}`)
        this.db_Diagram = this.cbData.data
        this.close_Window()
        d3.select(`#PHASE_${dia.PHASE}`).remove()
        this.draw_DiagramList(this.phase.list.find(f=> f.code == dia.PHASE)) // -----> draw_Database.js
    },


    exec_Procedure(selection, server, dia) {
      
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).style('opacity', .4)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).style('opacity', 1)
      })
      .on('click', ()=> {

        if(this.check_Procedure(server, dia)) {
          if(server == 'VERIFY') {
            return
          }
          let message = [
            {text: 'Once this store procedure is executed, ',},
            {text: 'it cannot be undone.',},
            {text: 'Do you want to proceed??',},
          ]
          this.exec_Popup(message, server, dia) // -----> set_Exection.js
        } else {
          let message = [
            {text: 'Cannot run Stroe Procedure!',},
            {text: 'You must enter all required data to run.',},
            {text: 'Do you want to open the editor Now?',},
          ]
          if(server == 'VERIFY') message = [{text: 'Please enter the MODAL number.!',}, {text: 'Do you want to open the editor Now?',}]
          this.exec_Popup(message, 'edit', dia) // -----> set_Execution.js
        }
      })

    },


    check_Procedure(server, dia) {

      dia = this.db_Diagram.find(f=> f.IDX == dia.IDX)

      if(server == 'VERIFY' && dia.VERIFY) return true
      else if(server == 'DEV' && dia.DEV_DB && dia.DEV_SCM && dia.DEV_SP) return true
      else if(server == 'SERVICE' && dia.SVS_DB && dia.SVS_SCM && dia.SVS_SP) return true
      else if(server == 'CUTOFF' && dia.CTO_DB && dia.CTO_SCM && dia.CTO_TBL && dia.CTO_CODE && dia.CTO_DATE) return true
      else return false
    },

  }
}